import { useQuery } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'
import {
  BuscaBibliotecaPageQuery,
  BuscaBibliotecaPageQueryVariables
} from '../../../core/types/graphql'
import { BUSCA_QUERY } from '../data/busca-query'

export const useTabelaBuscaArquivo = ({ searchText, pagination }) => {
  const { data: { buscaBibliotecaPaged } = {}, isLoading: loading } = useQuery({
    queryKey: ['buscaBibliotecaPaged', { searchText, pagination }],
    queryFn: async () =>
      await request<
        BuscaBibliotecaPageQuery,
        BuscaBibliotecaPageQueryVariables
      >(BUSCA_QUERY, {
        variables: {
          filterInput: {
            busca: searchText,
            page: pagination.pageIndex,
            rowsPerPage: pagination.pageSize
          }
        }
      })
  })

  return { buscaBibliotecaPaged, loading }
}
